
if(!customElements.get('load-more-collection')) {
  customElements.define('load-more-collection', class LoadMoreCollection extends HTMLElement {
    constructor() {
      super();
      this.loadMorebtn = this.querySelector('.collection-pagination__btn');
      this.collectionContentDiv = document.querySelector('#product-grid');
      if(this.loadMorebtn) this.loadMorebtn.addEventListener('click', this.loadMore.bind(this))
    }

    loadMore(evt) {
      evt.preventDefault();
      let nextUrl = this.querySelector('[data-next-link]').value;
      const loadMoreText = this.querySelector('[data-load-more-text]');
      const loadText = this.querySelector('[data-loading-text]');
      loadMoreText.classList.add('hidden');
      loadText.classList.remove('hidden');


      fetch(nextUrl)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        this.querySelector('[data-next-link]').value =  html.querySelector('[data-next-link]').value
        const nextProducts = html.querySelectorAll('#product-grid .product-item--gird').length > 0 ? html.querySelectorAll('#product-grid .product-item--gird') : html.querySelectorAll('#product-grid .product-card');
        nextProducts.forEach(card => {
          this.collectionContentDiv.append(card);
        })
      })
      .catch(error => console.error(error))
      .finally(()=> {
        loadMoreText.classList.remove('hidden');
        loadText.classList.add('hidden');
        if(this.querySelector('[data-next-link]').value.length <= 0) {
          loadMoreText.classList.add('hidden');
        }
      })
    }
  })
}
